"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaOpcoesConfiguracoesEducador = exports.yupOpcoesConfiguracoesEducador = exports.yupConfiguracoesEducador = void 0;
const yup = __importStar(require("yup"));
const configOpcoesMatricula_1 = require("./configOpcoesMatricula");
const configOpcoesCamposRematricula_1 = require("./configOpcoesCamposRematricula");
const configOnline_1 = require("./configOnline");
exports.yupConfiguracoesEducador = yup.object({
    codigo: yup.string().required().default('').label('Código da escola'),
    configOnline: configOnline_1.yupConfigOnline.label('Configurações do Módulo Online'),
    opcoes_matricula: configOpcoesMatricula_1.yupConfigOpcoesMatricula.label('Configurações de Matrícula e rematrícula'),
    campos_matricula: configOpcoesCamposRematricula_1.yupConfigMatriculaRematricula.label('Campos da matrícula e rematrícula'),
});
exports.yupOpcoesConfiguracoesEducador = yup.object({
    etapas: yup.boolean().notRequired().nullable().default(true).label('Etapas'),
    tiposAvaliacoes: yup.boolean().notRequired().nullable().default(true).label('Tipos de avaliações'),
    codigo: yup.boolean().notRequired().nullable().default(true).label('Código'),
    configOnline: yup.boolean().notRequired().nullable().default(true).label('Configurações do Módulo Online'),
    opcoes_matricula: yup
        .boolean()
        .notRequired()
        .nullable()
        .default(true)
        .label('Configurações da matrícula e rematrícula'),
    campos_matricula: yup
        .boolean()
        .notRequired()
        .nullable()
        .default(true)
        .label('Configurações de Campos da matrícula e rematrícula'),
    createdAt: yup.boolean().notRequired().nullable().default(true).label('Data de criação'),
    updatedAt: yup.boolean().notRequired().nullable().default(true).label('Data de atualização'),
});
exports.schemaOpcoesConfiguracoesEducador = exports.yupOpcoesConfiguracoesEducador.shape({});
